import { QuestionnaireCategoryItemsItemOneOfTwo as InterstitialType } from '@/api/generated-catch-backend/model';
import { useCallback } from 'react';
import { OnNext } from '../../../types';
import { InterstitialCardStack } from './interstitial-card-stack';
import { InterstitialImage } from './interstitial-image';
import { InterstitialIntro } from './interstitial-intro';
import { InterstitialLoader } from './interstitial-loader';
import { InterstitialOutro } from './interstitial-outro';
import { InterstitialVideoDrawer } from './interstitial-video-drawer';

export const Interstitial = ({ interstitial, onNext }: { interstitial: InterstitialType; onNext: OnNext }) => {
  const handleNext = useCallback(() => {
    onNext({ skipQuestion: true }); // treat interstitials as skipped questions
  }, [onNext]);
  switch (interstitial.type) {
    case 'intro':
      return <InterstitialIntro interstitial={interstitial} onNext={handleNext} />;
    case 'outro':
      return <InterstitialOutro interstitial={interstitial} onNext={handleNext} />;
    case 'card-stack-interstitial':
      return (
        <InterstitialCardStack
          title={interstitial.title}
          cards={interstitial.cards}
          cardStackTimeSeconds={interstitial.cardStackTimeSeconds || 5}
          onNext={handleNext}
        />
      );
    case 'image-interstitial':
      return <InterstitialImage interstitial={interstitial} onNext={handleNext} />;
    case 'video-drawer-interstitial':
      return <InterstitialVideoDrawer interstitial={interstitial} onNext={handleNext} />;
    case 'loader':
      return <InterstitialLoader interstitial={interstitial as any} onNext={handleNext} />;
    case 'section-divider-interstitial':
    case 'animated-section-divider':
    default:
      return <div>Interstitial type not implemented</div>;
  }
};
